var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',_vm._g(_vm._b({attrs:{"toptitle":"Schwerpunkt bearbeiten","title":_vm.influencerSubCategory.name,"name":"influencer-sub-category-edit","width":400}},'base-modal',_vm.$attrs,false),_vm.$listeners),[_c('influencer-sub-category-form',{attrs:{"influencerSubCategory":_vm.influencerSubCategory,"type":"edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }